module.exports = __webpack_public_path__ + "static/img/Doit-02.11c28b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Doit-02.png
// module id = GH0A
// module chunks = 0